import { apiRequest } from './httpClient';

export async function analyzeOriginsByCountry(payload) {
    return apiRequest('/analyze/origins', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    });
}

export async function analyzeCountries({ selectedTable, searchTerm, originFilter, countryFilter }) {
    const params = new URLSearchParams();
    if (searchTerm && searchTerm.trim()) {
        params.append('searchOriginMessage', searchTerm.trim());
    }
    if (originFilter && originFilter !== 'All Origins') {
        params.append('origin', originFilter);
    }
    if (countryFilter && countryFilter !== 'All Countries') {
        params.append('destination', countryFilter);
    }
    return apiRequest(`/analyze/${selectedTable}?${params.toString()}`);
}

export async function fetchSidSnapshot(refresh = false) {
    if (refresh) {
        return apiRequest('/access-list/refresh?fetch=false', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    }
    return apiRequest('/access-list/diff');
}
